export function decodeHtmlEntities (value) {
  if (typeof value !== 'string' || value === '') {
    return ''
  }

  const textarea = document.createElement('textarea')
  textarea.innerHTML = value

  return textarea.value.replace(/(['"])(?=[a-z-]+=)/gi, '$1 ')
}
